import TileWrapper from '../TileWrapper'
import { useTeam } from 'app/frontend/base/config/context/team'

const TeamDescriptionTile = () => {
  const { team } = useTeam()

  return (
    <TileWrapper>
      <p className='whitespace-pre-wrap wrap-break-word'>
        {team.description || 'No description set.'}
      </p>
    </TileWrapper>
  )
}

export default TeamDescriptionTile
